import { template } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import PageTitle from 'ember-page-title/helpers/page-title';
import Version from 'login/models/version';
interface WLoginDialogSignature {
    Element: HTMLDivElement;
    Args: {
        pageTitle: string;
        dialogTitle: string;
        version: Version;
    };
    Blocks: {
        default: [];
    };
}
const WLoginDialog: TemplateOnlyComponent<WLoginDialogSignature> = template(`
  {{PageTitle @pageTitle}}

  <div class='dialog' ...attributes>
    <div class='header grey'>
      {{@dialogTitle}}

      <div class='version'>
        {{@version.shortVersion}}
      </div>
    </div>

    {{yield}}

  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default WLoginDialog;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        WLoginDialog: typeof WLoginDialog;
    }
}
